"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Imprint = exports.BRAND = void 0;
var BRAND;
(function (BRAND) {
    BRAND["AUDI"] = "AUDI";
    BRAND["BENTLEY"] = "BENTLEY";
    BRAND["SKODA"] = "SKODA";
    BRAND["VW"] = "VW";
})(BRAND = exports.BRAND || (exports.BRAND = {}));
class Imprint {
    constructor(_s3Url = 'https://avp-aag-imprints-prod.s3.eu-west-1.amazonaws.com', _brand = BRAND.AUDI, _imprintFileName = 'imprint.html', _fallbackLocale = 'en-EN') {
        this.LOCALE_PATTERN = /^([a-z]{2}|([a-z]{2}-[a-zA-Z]{2}))$/g;
        this.supportedLocales = [
            'en-EN',
            'de-DE',
            'be-FR',
            'be-NL',
            'nl-NL',
            'fr-FR',
            'es-ES',
            'it-IT',
            'pt-PT',
            'sv-SV',
            'tr-TR'
        ];
        this.s3Url = _s3Url;
        this.brand = _brand;
        this.imprintFileName = _imprintFileName;
        this.fallbackLocale = _fallbackLocale;
    }
    resolve(locale) {
        const usedLocale = this.supportedLocales.find((supportedLang) => supportedLang.toLowerCase().startsWith(locale.toLowerCase()));
        if (!usedLocale) {
            console.log(`Used fallback locale ${this.fallbackLocale} instead of ${locale}.`);
            return this.fallbackLocale;
        }
        else {
            console.log(`Resolved language: ${usedLocale}`);
            return usedLocale;
        }
    }
    generatePath(resolvedLocale) {
        const localeParts = resolvedLocale.split('-');
        return `${this.s3Url}/${this.brand}/${localeParts[0]}/${localeParts[1]}/${this.imprintFileName}`;
    }
    path(locale) {
        const resolvedLocale = this.isLocaleString(locale) ? this.resolve(locale) : this.fallbackLocale;
        return this.generatePath(resolvedLocale);
    }
    isLocaleString(locale) {
        if (typeof locale !== 'string' || locale.search(this.LOCALE_PATTERN) < 0) {
            console.error(`Unsupported locale string: ${locale}. Locale must match pattern ${this.LOCALE_PATTERN} (e.g. en oder en-EN).`);
            return false;
        }
        return true;
    }
    removeImprintHeader(imprintHTML) {
        return imprintHTML.replace(/<h1>[a-zA-Z]*<\/h1><br\/>/, '');
    }
}
exports.Imprint = Imprint;
//# sourceMappingURL=imprint-lib.js.map